import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "v-step-0 cursor-pointer"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "v-step-6 nav-title" }
const _hoisted_10 = {
  key: 0,
  class: "text-decoration-none text-white",
  href: "https://www.codereadr.com/learn/",
  target: "_blank"
}
const _hoisted_11 = { class: "v-step-7 nav-title" }
const _hoisted_12 = ["href"]

import {onBeforeMount, ref, onMounted, getCurrentInstance, watch, computed} from "vue";
import {useRouter, useRoute, onBeforeRouteUpdate} from "vue-router";
import  moment from "moment";
import  FlashMessenger from "../service/FlashMessenger";
import Config from "../service/Config";
import util from "../service/UtilService";
import browserStorageService from '../service/BrowserStorageService';
import crApi from '../service/CrApi';
import axios from "axios";
import SecurityService from "../service/SecurityService";
import store from "../store/store";
import EventManager from "../service/AppEventManagerService";
import securityService from "../service/SecurityService";

declare const window: any;

export default /*@__PURE__*/_defineComponent({
  __name: 'MainTopNavComponent',
  setup(__props) {

const s3AuthMethod = ref([
  {id: 'pool_id', name: 'Identity Pool ID'},
  {id: 'access_key', name: 'Access Key'}
]);
const sftpAuthType = ref([
  {id: 'password', name: 'Username & Password'},
  {id: 'key', name: 'RSA Key'}
]);
const route = ref(useRoute());
const router = ref(useRouter());
const sidebar = ref(false);
const tab = ref(null);
const me = ref(null);
const v = ref('0.0.0');
const showEmailConfirmationPopup = ref(false);
const confirmText = ref('');
const showRetentionCleanupWarningModal = ref(false);
const processingNewTerms = ref(false);
const noInternetConnection = ref(false);
const latestVersion = ref(Config.version);
const taskBoxCount = ref(0);
const currentName = ref<any>('');
const websiteToken = ref(SecurityService.getToken());
const isAdminOnFreePlan = ref(false);
const isOwner = ref(null);
const currentTourStep = ref<any>(0);
const countTourStep = ref<any>(10);
const steps = ref([]);
const isFirstLogin = ref(false);
const inboxItem = ref(false);
const adminAccountId = ref('');
const username = ref(store.getters.getAdminEmail);
const signOutModal = ref(false);
const internalInstance = ref(getCurrentInstance());
const config = ref(Config);
const currentTourActive = ref(true);
const tours = ref<any>(internalInstance.value.appContext.config.globalProperties.$tours);
const securityServiceUserPromise = ref("securityService._userPromise");
const windowWidth = ref(window.innerWidth);
const mainPageCallbacks = ref({
  onPreviousStep: mainPageCustomPreviousStepCallback,
  onNextStep: mainPageCustomNextStepCallback,
  onSkip: onSkipTour,
  onFinish:onFinishTour,
});

const isMobile = computed(()=> {
  return windowWidth.value;
});

onBeforeMount(() => {
  EventManager.on('auth.signin', async ()=> {
    await load();
  });
  EventManager.on('auth.signout-pre', ()=> {
    // this.$bvModal.show('modalSignout');
    signOutModal.value = true;
  });
  EventManager.on('auth.signout-post', async ()=> {
    await checkUser();
    window.location.href = '/signin';
  });
})

onMounted(async () => {
  window.addEventListener('resize', () => {
    windowWidth.value = window.innerWidth;
  })
  if ((window.location.pathname === '/account/services/create-demo/' || window.location.pathname === '/account/pickinterests/') && route.value.query.firstLogin === "1") {
    isFirstLogin.value = true;
  }
  await load();
  await noStartTour(route.value,null);
});

onBeforeRouteUpdate (async (to,from,next) => {
  const response = await crApi.requestV2('task/inbox_item',{"website_token" : securityService.getToken()});
  inboxItem.value = response ? response.inboxHasItems : false;
  let requiresAuth = false;
  for (let r of route.value.matched) {
    if (r.meta.authenticate !== undefined) {
      requiresAuth = Boolean(r.meta.authenticate);
    }
  }
  currentName.value = to.path;
  if (requiresAuth) {
    checkEmailConfirmationSent();
  }
  await noStartTour(to,from);
  next();
});

watch(() => isMobile.value, () => {
  sidebar.value = !!(isMobile.value < 880 && sidebar.value);
})

watch(() => taskBoxCount.value, (newCount) => {
  taskBoxCount.value = newCount;
});

watch(() => securityServiceUserPromise.value, () => {
  checkUser();
}, {deep: true});

watch(() => route.value.fullPath,async (newVal,oldVal) => {
  await noStartTour(newVal,oldVal);
});

watch(() => tab.value, (newVal,oldVal) => {
  if (newVal === 'account') {
    tab.value = oldVal;
  }
})

async function load () {
  currentName.value = router.value.currentRoute.path;
  setInterval(() => {
    FlashMessenger.refresh();
  }, 500);
  store.subscribe((mutation, state) => {
    if (mutation.type === 'setAdminEmail') {
      username.value = state.adminEmail;
    }
  });
  const serviceData = await SecurityService.me();
  adminAccountId.value = serviceData ? serviceData.accountId : '';

  await checkUser();
  const versionChars = [];
  if (Config.version < 100) {
    versionChars.push(0);
  }
  for (let c of Config.version) {
    versionChars.push(c);
  }
  v.value = versionChars.join('.');

  let check = async () => {
    let ts = Math.round((new Date()).getTime() / 1000);
    const res = await axios.get('version.json?t=' + ts);
    let version = res.data;
    latestVersion.value = version.current;
    if (version.min > Config.version) {
      window.location.reload(true);
    }
  };
  await check();
  setInterval(check, 5 * 60 * 1000);

  let requiresAuth:any = false;
  for (let r of route.value.matched) {
    if (r.meta.requiresAuth !== undefined) {
      requiresAuth = r.meta.requiresAuth;
    }
  }
  if (me.value && parseInt(me.value.active) < 1 && !browserStorageService.getItem('emailConfirmationSent') && requiresAuth) {
    showEmailConfirmationPopup.value = true;
    browserStorageService.setItem('emailConfirmationSent', '1');
  }
  if(me.value){
    const pp = await crApi.requestV2('paymentplan/retrieve',{paymentPlanId: me.value.planId, "website_token" : securityService.getToken()});
    if (pp.status === 1 && pp.paymentPlan[0].textId === 'free') {
      isAdminOnFreePlan.value = true;
      /*if(me.value.adminProperty !== undefined){
          for (let p of me.value.adminProperty) {
              if (p.name === 'retentionCleanup') {
                  showRetentionCleanupWarningModal.value = !(p.value != '');
              }
          }
      }*/
    }
  }
  if (window.HubSpotConversations && me.value) {
    window.HubSpotConversations.on('conversationReady', function() {
      window.HubSpotConversations.widget.identify({
        email: me.value.username,
        name: '',
      });
    });
  }
  window.addEventListener("offline", () => {
    noInternetConnection.value = true;
  }, false);

  window.addEventListener("online", () => {
    noInternetConnection.value = false;
  }, false);


  if (window.location.pathname !== '/crapp/scan/edit/') {
    let lastReload = null;
    setInterval(async () => {
      let ts = Math.round((new Date()).getTime() / 1000);

      let reloadInterval = 2 * 60;

      if (lastReload == null || ts - lastReload >= reloadInterval) {
        lastReload = ts;
        const response = await crApi.requestV2('task/inbox_item',{"website_token" : securityService.getToken()});
        inboxItem.value = response ? response.inboxHasItems : false;
      }
    }, 1000);
  }
}

async function checkUser(){
  const response = await SecurityService.getUser();
  if (!response || response.error) {
    me.value = null;
    Config.crFormat = 'minimal';
  } else {
    me.value = response.admin[0];
    Config.crFormat = 'normal';
    if (me.value.username !== username.value) {
      store.commit('setAdminEmail', me.value.username);
    }
    isOwner.value = SecurityService.isOwner();
    const pickedInterest = me.value.pickedInterest;
    // const isDemoServiceSelected = me.value.isDemoServiceSelected;
    /*if (window.location.pathname != '/account/services/create-demo/') {
      if (isDemoServiceSelected !== undefined && isDemoServiceSelected !== '' && !parseInt(isDemoServiceSelected)) {
        window.location.href = '/account/services/create-demo/?firstLogin=1&noTour=1'
      }
    }*/

    if (window.location.pathname !=  '/pick-interest/') {
      if (pickedInterest !== undefined && pickedInterest !== '' && !parseInt(pickedInterest)) {
        window.location.href = '/pick-interest/?noTour=1&firstLogin=1';
      }
    }
  }
  checkEmailConfirmationSent();
  gAnalytic(response);
}

function checkEmailConfirmationSent() {
  let showConfirmation = false;
  if (me.value && Number(me.value.active) < 1 && !parseInt(browserStorageService.getItem('emailConfirmationSent')) && !SecurityService.getAccountUserId()) {
    showConfirmation = true;
    browserStorageService.setItem('emailConfirmationSent', '1');
  }

  if( currentName.value === '/account/firstlogin/' ){
    showEmailConfirmationPopup.value = false;
  }else{
    showEmailConfirmationPopup.value = showConfirmation;
  }
}

function hideEmailConfirmationPopup() {
  showEmailConfirmationPopup.value = false;
}

async function goToSettings() {
  // await router.value.push({name: "account.setting"});
  await router.value.push({});
}

async function sendConfirmMail(email) {
  const params = {
    "website_token" : websiteToken.value,
    "email": email
  };

  const admin = await crApi.requestV2('admin/activation_email', params)
  if (admin['status'] == 1) {
    confirmText.value = "A confirmation mail is sent to " + admin.username;
  } else {
    confirmText.value = "We are unable to process your request, kindly try again after sometime";
  }
}

/*async function acceptNewTerms() {
    if (processingNewTerms.value) {
        return;
    }
    processingNewTerms.value = true;

    const response = await crApi.requestV2('admin/update', {"website_token" : websiteToken.value, 'retention_cleanup': 1})
    if (response.status == 1) {
        processingNewTerms.value = false;
        showRetentionCleanupWarningModal.value = false;
    } else {
        await FlashMessenger.toastById(response.error._code, 'error');
        processingNewTerms.value = false;
    }
}*/

function formatTimePassed(date,format) {
  if (!date || date === undefined) {
    return null;
  }
  const dt = date.replace('T',' ');
  const res = dt.slice(0, 19);
  return moment(res).format(format);
}

function reloadNow() {
  window.location.reload(true);
}

function stepsParams() {
  return [
    {
      target: '.v-step-0',
      content: `<div class="text-left pa-2">
                        <div class="d-flex justify-space-between">
                            <h2 class="font-weight-bold">Getting Started</h2>
                            <span class="p-2 text-right">(1 of ${countTourStep.value})</span>
                        </div>
                        <div>Since it’s your first time here, let us show you around. To jump straight into configuring your own workflows (aka “Services”), simply click the “Skip tour” button below.</div>
                    </div>`,
      params: { placement: 'bottom', enableScrolling: false }
    },
    {
      target: '.v-step-1',
      content: `<div class="text-left p-2">
                        <div class="d-flex justify-space-between">
                            <h2 class="font-weight-bold">Services</h2>
                            <span class="p-2 text-right">(2 of ${countTourStep.value})</span>
                        </div>
                        <div>Here is where the services you created and optional demo services are listed. Click “Add a Service” to configure a new service. Click on the service name to edit, duplicate, or delete it.</div>
                    </div>`,
      params: { placement: 'bottom', enableScrolling: false }
    },
    {
      target: '.v-step-2',
      content: `<div class="text-left p-2">
                        <div class="d-flex justify-space-between">
                            <h2 class="font-weight-bold">Databases</h2>
                            <span class="p-2 text-right">(3 of ${countTourStep.value})</span>
                        </div>
                        <div>Services can be configured to validate (compare) scans against a database. Here is where you add your databases and can optionally generate QR codes for exporting.</div>
                    </div>`,
      params: { placement: 'bottom', enableScrolling: false }
    },
    {
      target: '.v-step-3',
      content: `<div class="text-left p-2">
                        <div class="d-flex justify-space-between">
                            <h2 class="font-weight-bold">Users</h2>
                            <span class="p-2 text-right">(4 of ${countTourStep.value})</span>
                        </div>
                        <div>Here you create app users authorized to use the mobile app to scan barcodes and collect data in the field. You can also <a href="/account/admins"><u>invite your team</u></a> and add admin users to manage your account.</div>
                    </div>`,
      params: { placement: 'bottom', enableScrolling: false }
    },
    {
      target: '.v-step-4',
      content: `<div class="text-left p-2">
                        <div class="d-flex justify-space-between">
                            <h2 class="font-weight-bold">Questions</h2>
                            <span class="p-2 text-right">(5 of ${countTourStep.value})</span>
                        </div>
                        <div>Questions are prompts presented to your mobile app users during the scanning process. Options include form fields, menu selections, GPS location, photo collect, and signature capture.</div>
                    </div>`,
      params: { placement: 'bottom', enableScrolling: false }
    },
    {
      target: '.v-step-5',
      content: `<div class="text-left p-2">
                        <div class="d-flex justify-space-between">
                            <h2 class="font-weight-bold">Scans</h2>
                            <span class="p-2 text-right">(6 of ${countTourStep.value})</span>
                        </div>
                        <div>Here you can filter, view, delete, and create export templates for exporting your scan records. Scan records can even be shared. There’s also a map view and photo grid.</div>
                    </div>`,
      params: { placement: 'bottom', enableScrolling: false }
    },
    {
      target: '.v-step-6',
      content: `<div class="text-left p-2">
                        <div class="d-flex justify-space-between">
                            <h2 class="font-weight-bold">Tasks</h2>
                            <span class="p-2 text-right">(7 of ${countTourStep.value})</span>
                        </div>
                        <div>Tasks are scheduled or on-demand actions for importing, exporting, and downloading records. Tasks help you automate the management of scans, databases, and users.</div>
                    </div>`,
      params: { placement: 'bottom', enableScrolling: false }
    },
    {
      target: '.v-step-7',
      content: `<div class="text-left p-2">
                        <div class="d-flex justify-space-between">
                            <h2 class="font-weight-bold">Settings</h2>
                            <span class="p-2 text-right">(8 of ${countTourStep.value})</span>
                        </div>
                        <div>Account settings and branding options can be edited here. Check your API usage, share links, billing, devices, and more.</div>
                    </div>`,
      params: { placement: 'bottom', enableScrolling: false }
    },
    {
      target: '.v-step-8',
      content: `<div class="text-left p-2">
                        <div class="d-flex justify-space-between">
                            <h2 class="font-weight-bold">Pricing</h2>
                            <span class="p-2 text-right">(9 of ${countTourStep.value})</span>
                        </div>
                        <div>The Free Plan allows you to test the services you’ve configured and scan with the mobile apps. Scans are limited to 50/month, but at any time you can upgrade to a paid plan when ready.</div>
                    </div>`,
      params: { placement: 'bottom', enableScrolling: false }
    },
    {
      target: '.v-step-9',
      content: `<div class="text-left p-2">
                        <div class="d-flex justify-space-between">
                            <h2 class="font-weight-bold">Support</h2>
                            <span class="p-2 text-right">(${countTourStep.value} of ${countTourStep.value})</span>
                        </div>
                        <div>Questions? Use the Knowledge Base or contact us via email or the website’s Chat Now utility (no bots!). Time to start scanning!</div>
                    </div>`,
      params: { placement: 'bottom', enableScrolling: false }
    },
  ]
}

async function againStartTour() {
  const account = await SecurityService.me();
  currentTourStep.value = 0;
  await crApi.requestV2('admin/set_tour_step', {tourName: 'TourMainPage', tourStep: currentTourStep.value, "website_token" : websiteToken.value});
  await startTour();
}

async function startTour () {
  steps.value = stepsParams();
  const account = await SecurityService.me();
  if (account) {
    if (account.role && account.role.includes('admin')) {
      countTourStep.value = 9;
      steps.value = stepsParams();
      steps.value[8] = steps.value[9];
      steps.value.length = 9;
    }
    const startTourStep = await crApi.requestV2('admin/get_tour_step',{tourName: 'TourMainPage', "website_token" : websiteToken.value});
    if (startTourStep.status === 1) {
      currentTourStep.value = parseInt(startTourStep.step);
      if (currentTourStep.value !== 999) {
        if (tours.value) {
          if (tours.value['tourMainPage']) {
            tours.value['tourMainPage'].start();
          }
        }
      }
    }
  }
  currentTourActive.value = false;
}

async function mainPageCustomPreviousStepCallback (currentStep) {
  const account = await SecurityService.me();
  currentTourStep.value = currentStep - 1;
  await crApi.requestV2('admin/set_tour_step',{tourName: 'TourMainPage', tourStep:currentTourStep.value, "website_token" : websiteToken.value});
}

async function mainPageCustomNextStepCallback (currentStep) {
  const account = await SecurityService.me();
  currentTourStep.value = currentStep + 1
  await crApi.requestV2('admin/set_tour_step',{tourName: 'TourMainPage', tourStep: currentTourStep.value, "website_token" : websiteToken.value});
}

async function onSkipTour () {
  const account = await SecurityService.me();
  currentTourStep.value = 999;
  await crApi.requestV2('admin/set_tour_step', {tourName: 'TourMainPage', tourStep: currentTourStep.value, "website_token" : websiteToken.value});
}

async function onFinishTour () {
  const account = await SecurityService.me();
  currentTourStep.value = 999;
  await crApi.requestV2('admin/set_tour_step', {tourName: 'TourMainPage', tourStep: currentTourStep.value, "website_token" : websiteToken.value});
}

async function noStartTour(to, from) {
  if ((to.query && !to.query.noTour || to.query && to.query.noTour != 1) && window.innerWidth > 880) {
    await startTour();
  }
}

async function gAnalytic(data) {
  const userAgent = navigator.userAgent.toLowerCase();
  const adminResponse = await securityService.me();
  const pickInterest = await crApi.requestV2('admin/retrieve_admin_property_value/', {
    adminId: adminResponse?.adminId,
    propertyName: "pick-interests",
    website_token: securityService.getToken()
  });
  const pickInterestValue  = pickInterest && pickInterest.status == 1 ? pickInterest.propertyValue[0].value : '';
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'user_account_details_loaded',
    user_account_details: {
      current_plan_id: data.admin[0].planId,
      picked_interest: pickInterestValue,
      first_paid_plan_id: data.admin[0].firstPaidPlanId || null,
      registration_source: data.admin[0].deviceType,
      was_demo_service_selected: data.admin[0].isDemoServiceSelected || 0
    }
  });
}

// Handle Add Company action
function handleAddCompany() {
  if (me.value && me.value.username) {
    const form = document.createElement('form');
    form.method = 'get';
    form.action = '/confirm-multi-account';

    const usernameInput = document.createElement('input');
    usernameInput.type = 'hidden';
    usernameInput.name = 'username';
    usernameInput.value = me.value.username;

    form.appendChild(usernameInput);
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }
}


return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_tour = _resolveComponent("v-tour")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!isFirstLogin.value)
      ? (_openBlock(), _createBlock(_component_v_app_bar, {
          key: 0,
          elevation: 4,
          app: "",
          class: "pl-0",
          color: "black"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_toolbar_title, { class: "text-no-wrap flex-0-0 mr-2" }, {
              default: _withCtx(() => [
                (me.value && me.value.privilege && Object.values(me.value.privilege).indexOf('webapp_scan_index') > -1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                      (isMobile.value > 1200)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: _unref(util).codereadrUrl()
                          }, [...(_cache[11] || (_cache[11] = [
                            _createElementVNode("img", {
                              src: "/images/logo_30.png",
                              alt: "logo"
                            }, null, -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_2))
                        : _createCommentVNode("v-if", true),
                      (isMobile.value < 1200 && isMobile.value > 880)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: _unref(util).codereadrUrl()
                          }, [...(_cache[12] || (_cache[12] = [
                            _createElementVNode("img", {
                              src: "/images/logo_cr.png",
                              alt: "logo"
                            }, null, -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_3))
                        : _createCommentVNode("v-if", true),
                      (isMobile.value < 880)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 2,
                            href: _unref(util).codereadrUrl()
                          }, [...(_cache[13] || (_cache[13] = [
                            _createElementVNode("img", {
                              src: "/images/logo_cr.png",
                              alt: "logo"
                            }, null, -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_4))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                      (isMobile.value > 1200)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: _unref(util).codereadrUrl()
                          }, [...(_cache[14] || (_cache[14] = [
                            _createElementVNode("img", {
                              src: "/images/logo_30.png",
                              alt: "logo"
                            }, null, -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_6))
                        : _createCommentVNode("v-if", true),
                      (isMobile.value < 1200 && isMobile.value > 880)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: _unref(util).codereadrUrl()
                          }, [...(_cache[15] || (_cache[15] = [
                            _createElementVNode("img", {
                              src: "/images/logo_cr.png",
                              alt: "logo"
                            }, null, -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_7))
                        : _createCommentVNode("v-if", true),
                      (isMobile.value < 880)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 2,
                            href: _unref(util).codereadrUrl()
                          }, [...(_cache[16] || (_cache[16] = [
                            _createElementVNode("img", {
                              src: "/images/logo_cr.png",
                              alt: "logo"
                            }, null, -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_8))
                        : _createCommentVNode("v-if", true)
                    ]))
              ]),
              _: 1 /* STABLE */
            }),
            (me.value && isMobile.value > 880)
              ? (_openBlock(), _createBlock(_component_v_tabs, {
                  key: 0,
                  modelValue: tab.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
                  "align-with-title": "",
                  "slider-color": "yellow"
                }, {
                  default: _withCtx(() => [
                    (me.value.privilege && Object.values(me.value.privilege).indexOf('webapp_scan_index') > -1)
                      ? (_openBlock(), _createBlock(_component_v_tab, {
                          key: 0,
                          value: "scan",
                          to: "/account/scans/",
                          class: "text-capitalize",
                          "hide-slider": route.value.meta.title !== 'Full View'
                        }, {
                          default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                            _createElementVNode("span", { class: "v-step-5 nav-title" }, "Scans", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["hide-slider"]))
                      : _createCommentVNode("v-if", true),
                    (me.value.privilege && Object.values(me.value.privilege).indexOf('webapp_service_index') > -1)
                      ? (_openBlock(), _createBlock(_component_v_tab, {
                          key: 1,
                          value: "service",
                          to: "/account/services/",
                          class: "text-capitalize",
                          "hide-slider": route.value.meta.title !== 'Services'
                        }, {
                          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                            _createElementVNode("span", { class: "v-step-1 nav-title" }, "Services", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["hide-slider"]))
                      : _createCommentVNode("v-if", true),
                    (me.value.privilege && Object.values(me.value.privilege).indexOf('webapp_database_index') > -1)
                      ? (_openBlock(), _createBlock(_component_v_tab, {
                          key: 2,
                          value: "database",
                          to: "/account/databases/",
                          class: "text-capitalize",
                          "hide-slider": route.value.meta.title !== 'Databases'
                        }, {
                          default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                            _createElementVNode("span", { class: "v-step-2 nav-title" }, "Databases", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["hide-slider"]))
                      : _createCommentVNode("v-if", true),
                    (me.value.privilege && Object.values(me.value.privilege).indexOf('webapp_user_index') > -1)
                      ? (_openBlock(), _createBlock(_component_v_tab, {
                          key: 3,
                          value: "user",
                          to: "/account/users/",
                          class: "text-capitalize",
                          "hide-slider": route.value.meta.title !== 'Users'
                        }, {
                          default: _withCtx(() => [
                            _cache[20] || (_cache[20] = _createElementVNode("span", { class: "v-step-3 nav-title" }, "Users", -1 /* CACHED */)),
                            _createCommentVNode("        <v-btn height=\"64px\" rounded=\"0\" class=\"align-self-center v-step-3 text-capitalize\" size=\"large\" @click.prevent>Users <v-icon end>mdi-menu-down</v-icon></v-btn>\n                <v-menu activator=\"parent\">\n                  <v-list>\n                    <v-list-item to=\"/account/users/\">All users</v-list-item>\n                    <v-list-item to=\"/account/admins\">Admins</v-list-item>\n                    <v-list-item to=\"/account/users/\">Mobile app users</v-list-item>\n                    <v-list-item to=\"/account/users/\">Username users</v-list-item>\n                    <v-list-item to=\"/account/users/\">Unverified users</v-list-item>\n                    <v-divider></v-divider>\n                    <v-list-item to=\"/account/users/new/\" prepend-icon=\"mdi-account-plus\">Add user</v-list-item>\n                  </v-list>\n                </v-menu>")
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["hide-slider"]))
                      : _createCommentVNode("v-if", true),
                    (me.value.privilege && Object.values(me.value.privilege).indexOf('webapp_question_index') > -1)
                      ? (_openBlock(), _createBlock(_component_v_tab, {
                          key: 4,
                          value: "question",
                          to: "/account/questions/",
                          class: "text-capitalize",
                          "hide-slider": route.value.meta.title !== 'Questions'
                        }, {
                          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                            _createElementVNode("span", { class: "v-step-4 nav-title" }, "Questions", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["hide-slider"]))
                      : _createCommentVNode("v-if", true),
                    (me.value.privilege && Object.values(me.value.privilege).indexOf('webapp_task_index') > -1)
                      ? (_openBlock(), _createBlock(_component_v_tab, {
                          key: 5,
                          value: "task",
                          to: "/account/tasks/listing/instance/",
                          class: "text-capitalize",
                          "hide-slider": route.value.meta.title !== 'Tasks'
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_9, [
                              _cache[22] || (_cache[22] = _createTextVNode(" Tasks", -1 /* CACHED */)),
                              (inboxItem.value)
                                ? (_openBlock(), _createBlock(_component_v_badge, {
                                    key: 0,
                                    dot: "",
                                    color: "yellow",
                                    class: "mb-4"
                                  }))
                                : _createCommentVNode("v-if", true)
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["hide-slider"]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"]))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_v_spacer),
            (isMobile.value > 1200 && isMobile.value > 800)
              ? (_openBlock(), _createBlock(_component_v_tabs, {
                  key: 1,
                  modelValue: tab.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event)),
                  "slider-color": "yellow"
                }, {
                  default: _withCtx(() => [
                    (me.value && me.value.privilege && Object.values(me.value.privilege).indexOf('webapp_scan_index') > -1)
                      ? (_openBlock(), _createBlock(_component_v_tab, {
                          key: 0,
                          value: "upgrade",
                          to: {name: 'account.plans'},
                          class: "text-capitalize",
                          "hide-slider": route.value.meta.title !== 'Plans'
                        }, {
                          default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                            _createElementVNode("span", { class: "v-step-8 nav-title" }, "Upgrade", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["hide-slider"]))
                      : _createCommentVNode("v-if", true),
                    (me.value?.adminId)
                      ? (_openBlock(), _createBlock(_component_v_tab, {
                          key: 1,
                          value: "learn",
                          class: "text-capitalize v-step-9 nav-title"
                        }, {
                          default: _withCtx(() => [
                            (isMobile.value > 1200)
                              ? (_openBlock(), _createElementBlock("a", _hoisted_10, "Learn"))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"]))
              : _createCommentVNode("v-if", true),
            (isMobile.value < 880)
              ? (_openBlock(), _createBlock(_component_v_app_bar_nav_icon, {
                  key: 2,
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (sidebar.value=!sidebar.value), ["stop"])),
                  color: "white"
                }))
              : _createCommentVNode("v-if", true),
            (!me.value)
              ? (_openBlock(), _createBlock(_component_v_tabs, {
                  key: 3,
                  modelValue: tab.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((tab).value = $event)),
                  "align-with-title": "",
                  class: "d-none d-sm-flex ml-7",
                  "slider-color": "yellow"
                }, {
                  default: _withCtx(() => [
                    (config.value.crFormat !== 'minimal')
                      ? (_openBlock(), _createBlock(_component_v_tab, {
                          key: 0,
                          value: "Knowledge Base"
                        }, {
                          default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                            _createElementVNode("a", {
                              href: "https://www.codereadr.com/learn/",
                              class: "link",
                              target: "_blank"
                            }, "Knowledge Base", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true),
                    (config.value.crFormat !== 'minimal')
                      ? (_openBlock(), _createBlock(_component_v_tab, {
                          key: 1,
                          value: "Create Account"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              color: "yellow",
                              variant: "flat",
                              href: "/registration/free/",
                              target: "_self"
                            }, {
                              default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                _createTextVNode("Create Account", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true),
                    _createVNode(_component_v_tab, { value: "home" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          href: "/",
                          target: "_self",
                          variant: "flat",
                          color: "gray"
                        }, {
                          default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                            _createTextVNode(" Home ", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_tab, { value: "signIn" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          href: "/signin",
                          target: "_self",
                          variant: "flat",
                          color: "gray"
                        }, {
                          default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                            _createTextVNode(" Sign In ", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"]))
              : _createCommentVNode("v-if", true),
            (me.value && me.value.username && isMobile.value > 880)
              ? (_openBlock(), _createBlock(_component_v_menu, {
                  key: 4,
                  class: "menu_right",
                  transition: "slide-y-transition"
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_tabs, {
                      modelValue: tab.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((tab).value = $event)),
                      "slider-color": "yellow",
                      "hide-slider": route.value.path === '/account/settings/'
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_tab, _mergeProps({ value: "account" }, props, { class: "text-capitalize" }), {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_11, [
                              _cache[28] || (_cache[28] = _createTextVNode("Account ", -1 /* CACHED */)),
                              _createVNode(_component_v_icon, { icon: "mdi-menu-down" })
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }, 16 /* FULL_PROPS */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "hide-slider"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, null, {
                      default: _withCtx(() => [
                        (me.value && me.value.privilege && me.value.multiAccount && Object.values(me.value.privilege).indexOf('webapp_scan_index') > -1)
                          ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                              default: _withCtx(() => [
                                _cache[30] || (_cache[30] = _createElementVNode("span", { class: "text-h6 text-grey-darken-2" }, "Profile", -1 /* CACHED */)),
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      icon: "mdi-account-circle",
                                      variant: "filled"
                                    }),
                                    _cache[29] || (_cache[29] = _createTextVNode("   ", -1 /* CACHED */)),
                                    _createElementVNode("b", {
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (router.value.push({ name: 'account.userprofile', query: {} }))),
                                      class: "cursor-pointer text-decoration-underline"
                                    }, _toDisplayString(me.value.username), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }))
                          : (me.value && me.value.privilege && Object.values(me.value.privilege).indexOf('webapp_scan_index') > -1)
                            ? (_openBlock(), _createBlock(_component_v_list_item, { key: 1 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, { icon: "mdi-account" }),
                                      _cache[31] || (_cache[31] = _createTextVNode("   ", -1 /* CACHED */)),
                                      _createElementVNode("b", {
                                        onClick: _cache[6] || (_cache[6] = ($event: any) => (router.value.push({ name: 'account.userprofile', query: {} }))),
                                        class: "cursor-pointer text-decoration-underline"
                                      }, _toDisplayString(me.value.username), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 1 /* STABLE */
                              }))
                            : (_openBlock(), _createBlock(_component_v_list_item, { key: 2 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, { icon: "mdi-account" }),
                                      _cache[32] || (_cache[32] = _createTextVNode("   ", -1 /* CACHED */)),
                                      _createElementVNode("b", null, _toDisplayString(me.value.username), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 1 /* STABLE */
                              })),
                        _createVNode(_component_v_divider),
                        (me.value)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 3,
                              to: {name: 'account.userprofile'}
                            }, {
                              default: _withCtx(() => [
                                _cache[33] || (_cache[33] = _createElementVNode("span", { class: "text-h6 text-grey-darken-2" }, "Company", -1 /* CACHED */)),
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { icon: "mdi-domain" }),
                                    _createTextVNode("   " + _toDisplayString(me.value.companyName), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }))
                          : _createCommentVNode("v-if", true),
                        (me.value && !me.value.isSsoEnabled)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 4,
                              onClick: handleAddCompany
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { icon: "mdi-office-building-plus" }),
                                    _cache[34] || (_cache[34] = _createTextVNode("   Add Company", -1 /* CACHED */))
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }))
                          : _createCommentVNode("v-if", true),
                        (me.value && me.value.multiAccount && !me.value.isSsoEnabled)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 5,
                              to: {name: 'security.select-company' }
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { icon: "mdi-swap-horizontal" }),
                                    _cache[35] || (_cache[35] = _createTextVNode("   Switch Company", -1 /* CACHED */))
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }))
                          : _createCommentVNode("v-if", true),
                        (me.value.multiAccount)
                          ? (_openBlock(), _createBlock(_component_v_divider, { key: 6 }))
                          : _createCommentVNode("v-if", true),
                        _createCommentVNode("        <v-list-item v-if=\"me && me.privilege && me.multiAccount && Object.values(me.privilege).indexOf('webapp_scan_index') > -1\">\n                   <v-list-item-title><v-icon icon=\"mdi-email-mark-as-unread\" /> &nbsp My Invitations</v-list-item-title>\n                </v-list-item>"),
                        (me.value && me.value.privilege && me.value.multiAccount && Object.values(me.value.privilege).indexOf('webapp_scan_index') > -1)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 7,
                              to: {name: 'account.user.create'}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { icon: "mdi-account-multiple-plus" }),
                                    _cache[36] || (_cache[36] = _createTextVNode("   Invite Your Team", -1 /* CACHED */))
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }))
                          : _createCommentVNode("v-if", true),
                        (me.value && me.value.privilege && Object.values(me.value.privilege).indexOf('webapp_scan_index') > -1)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 8,
                              to: {name: 'account.setting.general'}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { icon: "mdi-cog" }),
                                    _cache[37] || (_cache[37] = _createTextVNode("   Settings", -1 /* CACHED */))
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }))
                          : _createCommentVNode("v-if", true),
                        (isMobile.value < 1200 && isMobile.value > 880 && me.value && me.value.privilege && Object.values(me.value.privilege).indexOf('webapp_scan_index') > -1)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 9,
                              to: {name: 'account.plans'}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { icon: "mdi-arrow-up-bold-circle-outline" }),
                                    _cache[38] || (_cache[38] = _createTextVNode("   Upgrade", -1 /* CACHED */))
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }))
                          : _createCommentVNode("v-if", true),
                        (isMobile.value < 1200 && isMobile.value > 880)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 10,
                              href: "https://www.codereadr.com/learn/"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { icon: "mdi-school" }),
                                    _cache[39] || (_cache[39] = _createTextVNode("   Learn", -1 /* CACHED */))
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }))
                          : _createCommentVNode("v-if", true),
                        (tours.value.tourMainPage.currentStep === -1 && me.value && me.value.privilege && Object.values(me.value.privilege).indexOf('webapp_scan_index') > -1)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 11,
                              onClick: _cache[7] || (_cache[7] = ($event: any) => {againStartTour();tab.value=null})
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { icon: "mdi-flag" }),
                                    _cache[40] || (_cache[40] = _createTextVNode("   Start Tour", -1 /* CACHED */))
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }))
                          : _createCommentVNode("v-if", true),
                        _createVNode(_component_v_list_item, {
                          href: "https://www.codereadr.com/support-request/",
                          target: "_blank"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { icon: "mdi-face-agent" }),
                                _cache[41] || (_cache[41] = _createTextVNode("   Contact Us ", -1 /* CACHED */)),
                                _createVNode(_component_v_icon, {
                                  icon: "mdi-launch",
                                  size: "small",
                                  style: {"font-size":"14px"}
                                })
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_divider),
                        (me.value)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 12,
                              onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => {_unref(SecurityService).signOut();tab.value=null}, ["prevent"]))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { icon: "mdi-logout" }),
                                    _cache[42] || (_cache[42] = _createTextVNode("   Sign Out", -1 /* CACHED */))
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_v_navigation_drawer, {
      modelValue: sidebar.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((sidebar).value = $event)),
      location: "right",
      style: {"background":"black","color":"white"},
      "disable-resize-watcher": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_list_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_list_item_title, { class: "mt-2" }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  href: _unref(util).codereadrUrl()
                }, [...(_cache[43] || (_cache[43] = [
                  _createElementVNode("img", {
                    src: "/images/logo_cr.png",
                    alt: "logo"
                  }, null, -1 /* CACHED */)
                ]))], 8 /* PROPS */, _hoisted_12)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_v_divider, {
          class: "mb-6",
          thickness: 3
        }),
        (me.value && me.value.privilege && Object.values(me.value.privilege).indexOf('webapp_scan_index') > -1)
          ? (_openBlock(), _createBlock(_component_v_list_item, {
              key: 0,
              link: "",
              title: "Scans",
              to: "/account/scans/"
            }))
          : _createCommentVNode("v-if", true),
        (me.value && me.value.privilege && Object.values(me.value.privilege).indexOf('webapp_service_index') > -1)
          ? (_openBlock(), _createBlock(_component_v_list_item, {
              key: 1,
              link: "",
              title: "Services",
              to: "/account/services/"
            }))
          : _createCommentVNode("v-if", true),
        (me.value && me.value.privilege && Object.values(me.value.privilege).indexOf('webapp_database_index') > -1)
          ? (_openBlock(), _createBlock(_component_v_list_item, {
              key: 2,
              link: "",
              title: "Databases",
              to: "/account/databases/"
            }))
          : _createCommentVNode("v-if", true),
        (me.value && me.value.privilege && Object.values(me.value.privilege).indexOf('webapp_user_index') > -1)
          ? (_openBlock(), _createBlock(_component_v_list_item, {
              key: 3,
              link: "",
              title: "Users",
              to: "/account/users/"
            }))
          : _createCommentVNode("v-if", true),
        (me.value && me.value.privilege && Object.values(me.value.privilege).indexOf('webapp_question_index') > -1)
          ? (_openBlock(), _createBlock(_component_v_list_item, {
              key: 4,
              link: "",
              title: "Questions",
              to: "/account/questions/"
            }))
          : _createCommentVNode("v-if", true),
        (me.value && me.value.privilege && Object.values(me.value.privilege).indexOf('webapp_task_index') > -1)
          ? (_openBlock(), _createBlock(_component_v_list_item, {
              key: 5,
              link: "",
              title: "Tasks",
              to: "/account/tasks/listing/instance/"
            }))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_v_divider, {
          class: "my-6",
          thickness: 3
        }),
        (me.value && me.value.privilege && Object.values(me.value.privilege).indexOf('webapp_scan_index') > -1)
          ? (_openBlock(), _createBlock(_component_v_list_item, {
              key: 6,
              link: "",
              title: "Upgrade",
              to: {name: 'account.plans'}
            }))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_v_list_item, {
          link: "",
          title: "Learn",
          href: "https://www.codereadr.com/learn/"
        }),
        _createVNode(_component_v_divider, {
          class: "my-6",
          thickness: 3
        }),
        (me.value)
          ? (_openBlock(), _createBlock(_component_v_list_item, {
              key: 7,
              link: "",
              title: me.value.username,
              subtitle: "Username",
              to: {name: 'account.userprofile'}
            }, null, 8 /* PROPS */, ["title"]))
          : _createCommentVNode("v-if", true),
        (me.value && me.value.privilege && me.value.multiAccount && Object.values(me.value.privilege).indexOf('webapp_scan_index') > -1)
          ? (_openBlock(), _createBlock(_component_v_list_item, {
              key: 8,
              to: {name: 'account.userprofile'}
            }, {
              default: _withCtx(() => [
                _cache[44] || (_cache[44] = _createElementVNode("span", { class: "text-h6 text-grey-darken-2" }, "Company", -1 /* CACHED */)),
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(me.value.multiAccount.companyName), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        (me.value && !me.value.isSsoEnabled)
          ? (_openBlock(), _createBlock(_component_v_list_item, {
              key: 9,
              onClick: handleAddCompany
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                    _createTextVNode("Add Company", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        (me.value && me.value.multiAccount && !me.value.isSsoEnabled)
          ? (_openBlock(), _createBlock(_component_v_list_item, {
              key: 10,
              to: {name: 'security.select-company' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                    _createTextVNode(" Switch Company ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        (me.value && me.value.multiAccount)
          ? (_openBlock(), _createBlock(_component_v_list_item, {
              key: 11,
              to: {name: 'account.user.create'}
            }, {
              default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                _createTextVNode(" Invite Your Team ", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        (me.value && me.value.privilege && Object.values(me.value.privilege).indexOf('webapp_scan_index') > -1)
          ? (_openBlock(), _createBlock(_component_v_list_item, {
              key: 12,
              link: "",
              title: "Settings",
              to: {name: 'account.setting.general'}
            }))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_v_list_item, {
          href: "https://www.codereadr.com/support-request/",
          target: "_blank",
          title: "Contact Us"
        }),
        (me.value)
          ? (_openBlock(), _createBlock(_component_v_list_item, {
              key: 13,
              title: "Sign out",
              onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_unref(SecurityService).signOut()), ["prevent"]))
            }))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"]),
    _createVNode(_component_v_tour, {
      name: "tourMainPage",
      steps: steps.value,
      id: "v-tour-step",
      callbacks: mainPageCallbacks.value
    }, null, 8 /* PROPS */, ["steps", "callbacks"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})